// API 문서 상단의 위치 표시·버전 선택·제목을 렌더하는 컴포넌트
import classes from './DescriptionPageTemplate.module.css';

/**
 * 이 문서가 속한 카테고리 이름을 찾는다.
 * 카테고리는 문서 데이터에 필드로 없고 사이드 내비 그룹 구조에만 있다.
 */
function findCategory(filteredPageDataList, docTitle) {
  const group = (filteredPageDataList || []).find((item) =>
    (item.children || []).some((child) => child.title === docTitle)
  );
  return group?.title;
}

/**
 * 문서 머리.
 * breadcrumb, 버전 셀렉트, 제목을 렌더한다.
 */
const DocHeader = ({ title, docTitle, versions, versionIndex, onVersionChange, filteredPageDataList }) => {
  const category = findCategory(filteredPageDataList, docTitle);
  const hasMultipleVersions = versions.length > 1;

  return (
    <div className={classes.docHeader}>
      <div className={classes.docHeaderTop}>
        <nav className={classes.crumb} aria-label="위치">
          <span>Open API</span>
          {category && (
            <>
              <span className={classes.crumbSep}>/</span>
              <span>{category}</span>
            </>
          )}
          <span className={classes.crumbSep}>/</span>
          <span className={classes.crumbCurrent}>{docTitle}</span>
        </nav>

        <div className={classes.version}>
          <label className={classes.versionLabel} htmlFor="doc-version-select">
            버전
          </label>
          <select
            id="doc-version-select"
            className={classes.versionSelectNew}
            value={versionIndex}
            onChange={onVersionChange}
            /* 버전이 하나면 고를 것이 없다. 값은 보여주되 조작을 막는다 */
            disabled={!hasMultipleVersions}
          >
            {versions.map((data, index) => (
              <option key={data.version} value={index}>
                {data.version}
              </option>
            ))}
          </select>
        </div>
      </div>

      <h1 className={classes.docTitle}>{title}</h1>
    </div>
  );
};

export default DocHeader;
